/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadShipmentDocumentRequest
 */
export interface UploadShipmentDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadShipmentDocumentRequest
     */
    shipmentId: string;
    /**
     * One of shipper_photo, bill_of_lading, proof_of_delivery. Unknown values fall back to shipper_photo.
     * @type {string}
     * @memberof UploadShipmentDocumentRequest
     */
    documentType: string;
    /**
     * MIME type of the base64 content, e.g. image/jpeg or application/pdf.
     * @type {string}
     * @memberof UploadShipmentDocumentRequest
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadShipmentDocumentRequest
     */
    base64Content: string;
}

/**
 * Check if a given object implements the UploadShipmentDocumentRequest interface.
 */
export function instanceOfUploadShipmentDocumentRequest(value: object): value is UploadShipmentDocumentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('base64Content' in value) || value['base64Content'] === undefined) return false;
    return true;
}

export function UploadShipmentDocumentRequestFromJSON(json: any): UploadShipmentDocumentRequest {
    return UploadShipmentDocumentRequestFromJSONTyped(json, false);
}

export function UploadShipmentDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadShipmentDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'documentType': json['documentType'],
        'contentType': json['contentType'],
        'base64Content': json['base64Content'],
    };
}

  export function UploadShipmentDocumentRequestToJSON(json: any): UploadShipmentDocumentRequest {
      return UploadShipmentDocumentRequestToJSONTyped(json, false);
  }

  export function UploadShipmentDocumentRequestToJSONTyped(value?: UploadShipmentDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'documentType': value['documentType'],
        'contentType': value['contentType'],
        'base64Content': value['base64Content'],
    };
}

